import { H5 } from '../../../../../common/components/Typography/Heading/Heading.styles';
import { TELEHEALTH_SERVICES_LANDING_URL } from '../../../../../common/constants';
import { useRouter } from '../../../../../common/hooks/useRouter';
import {
  GpTelehealthCardImage,
  GpTelehealthCardList,
  GpTelehealthCardFooter,
  GpTelehealthCardPrice,
  GpTelehealthCardButton,
  GpTelehealthCardImageContainer,
  Card,
  AdvertisementIndicator,
} from './GpTelehealthCard.styles';

export const GpTelehealthCard = () => {
  const router = useRouter();

  const onClick = (): void => {
    void router?.push(`${TELEHEALTH_SERVICES_LANDING_URL}?source=GPSER`);
  };

  return (
    <Card
      compact
      flat
      imagePosition="left"
      imageElement={
        <GpTelehealthCardImageContainer>
          <GpTelehealthCardImage src="/public/images/e7e71842-7141-4625-b748-3db38c8400ef_20220614085934.jpeg" />
          <AdvertisementIndicator>ADVERTISEMENT</AdvertisementIndicator>
        </GpTelehealthCardImageContainer>
      }
    >
      <H5>Want more options? Consider Telehealth</H5>
      <GpTelehealthCardList>
        <li>Phone, video and online form options</li>
        <li>General consults, medical certs, scripts & more</li>
        <li>Multiple featured partners</li>
      </GpTelehealthCardList>
      <GpTelehealthCardFooter>
        <GpTelehealthCardPrice>from $19</GpTelehealthCardPrice>
        <GpTelehealthCardButton onClick={onClick}>See GP Telehealth options</GpTelehealthCardButton>
      </GpTelehealthCardFooter>
    </Card>
  );
};
